import { clone, isEqualWith, pick } from "lodash";
import { MUCCountryCodes } from "@/core/constants/address-country-configs";
import type { AnyAddressType } from "../../types";
import type { InputMemberAddressType, MemberAddressTypeExtension } from "@/core/api/graphql/types";

// FIXME: https://virtocommerce.atlassian.net/browse/ST-5122
export function toInputAddress(address: AnyAddressType): InputMemberAddressType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const newAddress = clone(address) as Record<keyof MemberAddressTypeExtension, any>;

  newAddress.key = newAddress.id;
  newAddress.addressType = address.addressType;
  delete newAddress.id;
  delete newAddress.isDefault;
  delete newAddress.isFavorite;

  return newAddress;
}

export function getAddressName(address: AnyAddressType): string {
  const { countryCode, regionName, city, line1 } = address;
  return [countryCode, regionName, city, line1].filter(Boolean).join(", ");
}

export function isEqualAddresses(
  address1: AnyAddressType,
  address2: AnyAddressType,
  options: { skipDescription?: boolean; compareERPIdTL?: boolean } = {},
): boolean {
  const { skipDescription = true, compareERPIdTL: compareERPIdTL = false } = options;
  const verifiableProperties: Array<keyof MemberAddressTypeExtension> = [
    "firstName",
    "lastName",
    "city",
    "line1",
    "line2",
    "countryCode",
    "regionId",
    "postalCode",
    "phone",
    "email",
    "buildingTL",
    "countyTL",
    "districtTL",
    "departmentTL",
    "mailStopTL",
    "taxExemptNoTL",
    "gstinTL",
  ];

  if (!skipDescription) {
    verifiableProperties.push("description");
  }
  if (compareERPIdTL) {
    verifiableProperties.push("eRPIDTL");
  }

  const customizer = (value: unknown, other: unknown) => {
    if ((value === null || value === "") && (other === null || other === "")) {
      return true;
    }
  };

  const first = pick(address1, verifiableProperties);
  const second = pick(address2, verifiableProperties);

  return isEqualWith(first, second, customizer);
}

export function isMemberAddressType(address: AnyAddressType): address is MemberAddressTypeExtension {
  return "description" in address;
}

export function isChinaOrJapan(countryCode: string): boolean {
  return countryCode === "CHN" || countryCode === "JPN";
}

export function isMUCCountry(countryCode: string): boolean {
  return MUCCountryCodes.includes(countryCode);
}
